import React from 'react';
import './ChartsDashboard.css';
import { Typography } from 'antd';
import { Bar } from 'react-chartjs-2';
interface Props {
  kyc: {
    tier1: {
      count: number
    },
    tier2: {
      count: number
    },
    tier0: {
      count: number
    },
  },
  t: any
}

export const KYCTier = ({ kyc, t }: Props) => {
  const { Text } = Typography;
  return <>
        <div className='titleBox'><Text className='titleBlackBox' >{t('KYC_WITH_TIER')}</Text></div>
        <div className='boxActiveSensors'>
            <div> <Bar data={{
              labels: [
                'Tier 1',
                'Tier 2',
                t('KYC_WITH_NOT_TIER')
              ],
              datasets: [{
                label: t('KYC_WITH_TIER'),
                data: [kyc?.tier1?.count, kyc?.tier2?.count, kyc?.tier0?.count],
                backgroundColor: [
                  'rgba(255, 99, 132, 0.2)'
                ],
                borderColor: [
                  'rgb(255, 99, 132)'
                ],
                borderWidth: 1
              }]
            }
            }
                // style={{ marginTop: 50 }}
                options={{
                  scales: {
                    x: {
                      stacked: true
                    },
                    y: {
                      stacked: true
                    }
                  }
                }} />
            </div>
        </div>

    </>;
};